import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@common-fe/common-fe';

interface Props {
  hasOptions: boolean;
  searchProviderText: string;
}

const ProviderDropdownPlaceholder: React.FC<Props> = ({ hasOptions, searchProviderText }) => {
    const { t } = useTranslation();

  if (searchProviderText?.length >= 3) {
    return t('No results found.');
  }

  if (!hasOptions) {
    return (
      <Text size="small">
        {t('No providers added.')}
        <br />
        {t('Use the [+] button or keep typing to create a provider.')}
      </Text>
    );
  }

  if (searchProviderText?.length >= 1) {
    return (
      <Text size="small">
        {t('No results found.')}
        <br />
        {t('Keep typing to create a provider.')}
      </Text>
    );
  }

  return null;
};

export default ProviderDropdownPlaceholder;
